import styled from 'styled-components';

export const Container = styled.div`
  height: inherit;
  width: inherit;

  .custom-tooltip-modal {
    border-radius: 8px;

    background-color: white;

    width: auto;
  }

  .custom-tooltip-modal-open {
    border-radius: 8px;

    width: auto;
  }

  .custom-tooltip {
    word-break: break-word;
    white-space: pre-wrap;
    background-color: white;
    color: black;
    opacity: 1 !important;

    border-radius: 8px;

    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);

    max-height: 1200px;

    text-align: center;
  }

  .custom-tooltip::before {
    border-right: none !important;
  }
`;

export default {
  Container,
};
